import { Modal, ModalBody } from 'reactstrap';
import ModalCloseBtn from '../../../../images/close_icon.svg';
import BottomGroup from '../../../../images/bottom-group.png';
import creditCheck from '../../../../images/Soft-Credit-Check.svg';
import clockTime from '../../../../images/Layer 3.svg';
import calendar from '../../../../images/interest.svg';
import '../../cart/clinic-cart.scss';

function Payl8rPopup({ isOpen, onClose, payl8rData }) {
    return (
        <Modal
            isOpen={isOpen}
            toggle={() => onClose()}
            backdrop={true}
            backdropClassName="modal-backdrop-blur"
            scrollable="true"
            modalClassName="big-modal"
        >
            <img
                src={ModalCloseBtn}
                width={60}
                height={60}
                className="btn modal-close-btn"
                onClick={() => onClose()}
                alt="close button"
            />
            <ModalBody cssModule="big-modal">
                <div className="outer-div">
                    <div style={{ alignItems: 'center', textAlign: 'center' }}>
                        <p className="heading">Spread the cost with Buy Now Pay Later</p>

                        <div className="totalDiv">
                            <div className="total-div">
                                <p className="total-txt">Total cost</p>{' '}
                                <span className="total-price">{'£' + payl8rData?.amount || 0}</span>
                            </div>
                            <div className="total-sub-div">
                                <div className="line"></div>

                                <p className="title-txt">
                                    Why not <span className="title-txt-sub">spread</span> the cost?
                                </p>
                            </div>
                        </div>

                        <div className="items-div">
                            <div className="item-div">
                                <img src={clockTime} alt="" height={30} width={30} />
                                <span class="item-txt">Quick application process</span>
                            </div>

                            <div className="item-div">
                                <img src={calendar} alt="" height={30} width={30} />
                                <span class="item-txt">0% Interest if fully paid in 90 days</span>
                            </div>

                            <div className="item-div">
                                <img src={creditCheck} alt="" height={30} width={30} />
                                <span class="item-txt">Soft Credit check</span>
                            </div>
                        </div>
                        <div className="three-month-div">
                            <div class="three-month-div-first">
                                <span class="three-month-txt">3 Months</span>
                                <span class="three-month-txt-sub">0% interest!</span>
                            </div>

                            <div class="three-month-div-second">
                                <span className="three-month-div-second-txt">
                                    {`Pay £${payl8rData?.['3Month']?.monthlyPaymentAmount} `}
                                    <span className="star">*</span> / pm
                                </span>
                            </div>
                        </div>

                        <div className="months-div">
                            <div class="month-div">
                                <div class="custom-pay-paymant">
                                    <span className="month-txt">6 Months</span>
                                </div>
                                <div class="custom-pay-total">
                                    <span className="pay-txt"> Pay </span>
                                    <span className="amt-txt">
                                        {' '}
                                        {`£${payl8rData?.['6Month']?.monthlyPaymentAmount}`}
                                        <span className="star">*</span>
                                        <span className="amt-txt"> / pm</span>
                                    </span>
                                </div>
                            </div>
                            <div class="month-div">
                                <div class="custom-pay-paymant">
                                    <span className="month-txt">9 Months</span>
                                </div>
                                <div class="custom-pay-total">
                                    <span className="pay-txt"> Pay </span>
                                    <span className="amt-txt">
                                        {' '}
                                        {`£${payl8rData?.['9Month']?.monthlyPaymentAmount}`}
                                        <span className="star">*</span>
                                        <span className="amt-txt"> / pm</span>
                                    </span>
                                </div>
                            </div>
                            <div class="month-div">
                                <div class="custom-pay-paymant">
                                    <span className="month-txt">12 Months</span>
                                </div>
                                <div class="custom-pay-total">
                                    <span className="pay-txt"> Pay </span>
                                    <span className="amt-txt">
                                        {' '}
                                        {`£${payl8rData?.['12Month']?.monthlyPaymentAmount}`}
                                        <span className="star">*</span>
                                        <span className="amt-txt"> / pm</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="line-h"></div>

                        <p className="para">
                            For approval: Must be 18. Have a UK bank account, regular monthly
                            income, have your card & account details ready.{' '}
                            <span className="star">*</span>Rates, totals & monthly amounts are
                            indicative and subject to status. EXAMPLE: Subject to affordability
                            assessments - Application fees will apply. (Full legal name and trading
                            style where applicable) is an Introducer Appointed Representative of
                            Social Money LTD t/a Payl8r. Representative Example: If you borrow £200
                            over 12 mths at a fixed monthly interest rate of 4% and an annual rate
                            of 48% and representative annual percentage rate of 127.34%. You will
                            pay. Monthly payment: £24.66. Total amount you repay: £295.92 Total
                            charge for credit: £95.92 Missed payment may affect your Credit File,
                            future borrowing and incur fees. Our online application takes just 60
                            seconds to complete and, in most cases, we'll be able to give you an
                            instant decision. Please note: For a small majority of customers, your
                            application may require additional information and therefore it can take
                            longer. You will be notified by email if your application is sent for
                            further review.
                        </p>
                    </div>
                </div>
                <img
                    alt="bottom"
                    src={BottomGroup}
                    className="bottom-group"
                    style={{ width: '100%' }}
                />
            </ModalBody>
        </Modal>
    );
}
export default Payl8rPopup;
